// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Box, Markdown, Paragraph, Anchor } from 'grommet'
import PropTypes from 'prop-types'

import { Typography } from '../../../../components'

const AdditionalResults = ({ data, i18nTranslation, handleActionClick }) => (
  <Box
    pad={{ bottom: 'medium' }}
    border={{
      side: 'bottom',
      color: 'border-weak',
      size: 'small'
    }}
  >
    <Typography
      type="text"
      testId="additional-result-title"
      color="text-weak"
      size="xsmall"
      margin={{ vertical: 'small' }}
    >
      {i18nTranslation('global_search.additional_result')}
    </Typography>
    <Box gap="medium">
      {data &&
        data.map((item) => (
          <Box gap="xsmall" key={item.title}>
            <Typography
              type="heading"
              level="3"
              testId="additional-results-title"
            >
              <Anchor
                data-testid="additional-results-action"
                href={item.link}
                target="_blank"
                label={item.title}
                onClick={() => handleActionClick(item.title)}
              />
            </Typography>
            <Typography
              type="paragraph"
              maxLines={2}
              testId="additional-results-description"
              fill
            >
              <Markdown
                components={{
                  p: {
                    component: Paragraph,
                    props: {
                      fill: 'true',
                      margin: 'none'
                    }
                  }
                }}
              >
                {item.matchingLine}
              </Markdown>
            </Typography>
          </Box>
        ))}
    </Box>
  </Box>
)

AdditionalResults.propTypes = {
  data: PropTypes.array.isRequired,
  i18nTranslation: PropTypes.any.isRequired,
  handleActionClick: PropTypes.func.isRequired
}

export { AdditionalResults }
